import script from "./VehicleListingsBestDeals.vue?vue&type=script&lang=js"
export * from "./VehicleListingsBestDeals.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__